import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default ({ open, message, handleClose, title }) => {
    return (
        <div>
            <Dialog maxWidth="xs"
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle style={{ padding: '12px 24px 8px' }} id="alert-dialog-title">{title || 'Besked'}</DialogTitle>
                <DialogContent style={{ padding: '0 24px' }} >
                    <DialogContentText style={{ margin: 0 }} id="alert-dialog-description">{message}</DialogContentText>
                </DialogContent>
                <DialogActions style={{ padding: '0 8px 8px' }}>
                    <Button onClick={handleClose} color="primary" autoFocus>Luk</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}